import React, { useState, useEffect } from 'react';
import { getCookie } from 'cookies-next';

import { Layout } from 'components/Layout';
import { ReleaseHero } from 'components/sections/ReleaseHero';
import { releaseReviews } from 'content/reviews';
import { Reviews } from 'components/sections/Reviews';
import { howToCardsRelease } from 'content/howToCards';
import { HowToCards } from 'components/sections/HowToCards';
import { Magazine, MagazineArticleCard } from 'components/sections/Magazine';
import { Faq, Topic } from 'components/sections/Faq';
import { Gutter } from 'components/Gutter';
import { releaseQuotes } from 'content/quotes';
import { Quote } from 'components/Quote';
import { SeoContent } from 'components/SeoContent';

interface Props {
  articles: MagazineArticleCard[];
  faq: {
    title: string;
    questions: Topic[];
  };
}

export const Release: React.FC<Props> = ({ articles, faq }) => {
  const [referal, setReferal] = useState('');
  useEffect(() => {
    setReferal((getCookie('ref') || '') as string);
  }, []);

  return (
    <Layout>
      <ReleaseHero partner={referal} />

      <Gutter size="medium">
        <Quote text={releaseQuotes[0].text} byline={releaseQuotes[0].byline} />
      </Gutter>

      <Gutter size="small">
        <HowToCards
          hideImages
          title={howToCardsRelease.title}
          howToItems={howToCardsRelease.howToItems}
          showBg
          showIcons
        />
      </Gutter>
      <Gutter size="small">
        <SeoContent>
          <h2>
            <span>
              Lägg om din företagsleasing - så kan du sänka månadskostnaden på leasingbilen
            </span>
          </h2>
          <p>
            <strong>
              När omvärlden svänger, då är det klokt att hålla kostnaderna i schack. Visste du att
              din leasingbil kan ha potential att sänka dina kostnader? Med rätt omförhandling, kör
              du vidare, men billigare.
            </strong>
          </p>
          <p>
            Många bilar har ett övervärde jämfört med restvärdet och det finns goda möjligheter att
            komma ner i månadskostnad — ofta flera tusenlappar på en dyrare bil. Att behålla sin bil
            har ofta flera fördelar, bland annat slipper man värdeminskningen det innebär med en ny
            bil, samt att du troligen har en lägre fordonsskatt på din nuvarande.
          </p>
          <p>
            Att lägga om sitt leasingavtal på Blipp är smidigt — du behöver bara skicka in en
            intresseanmälan för en kostnadsfri offert. Väljer du att tacka ja så får du hjälp av en
            leasingexpert hela vägen till din nya månadskostnad.
          </p>
          <p>
            Förbättra ditt leasingavtal:
            <ul>
              <li>Kom ner i måndaskostnad</li>
              <li>Försäkringserbjudande från Trygg-Hansa ingår</li>
              <li>Blipp sköter hela affären med digital signering</li>
            </ul>
          </p>
          <p>Gör som hundratals nöjda företagare och lägg om din företagsleasing med Blipp.</p>
        </SeoContent>
      </Gutter>
      <Gutter size="medium">
        <Reviews title={releaseReviews.title} reviews={releaseReviews.reviews} />
      </Gutter>

      <Gutter size="medium">
        <Faq title={faq.title} questions={faq.questions} />
      </Gutter>

      <Gutter size="medium">
        <Magazine articles={articles} />
      </Gutter>
    </Layout>
  );
};
